import { fetch } from "@/helpers";

export const authService = {
  logon,
  refreshToken,
  logout,
  signup,
  sendMessage,
  sendEmails,
  sendEmailsToAll,
  getEmailTemplates,
  getUserProfile,
  getUserProfiles,
  editUserProfile,
  changePassword,
  resetPassword,
  createPilotPassword
};

export function logon(user) {
  return fetch.post("/1/auth/logon/", user);
}

export function refreshToken() {
  return fetch.post("/1/auth/token/refresh/");
}

export function logout() {
  return fetch.post("/1/auth/logout/");
}

export function signup(user) {
  return fetch.post("/1/auth/signup/", user);
}

export function sendMessage(message) {
  return fetch.post(
    "/1/auth/sendmessage/",
    (({ firstname, lastname, subjects, message, email }) => ({
      firstname,
      lastname,
      subjects,
      message,
      email
    }))(message)
  );
}

export function sendEmails(payload) {
  return fetch.post(
    "/1/auth/sendemails/",
    (({ template, emails }) => ({
      template,
      emails
    }))(payload)
  );
}

export function sendEmailsToAll(payload) {
  return fetch.post(
    "/1/auth/sendemailstoall/",
    (({ template, newsletter_only }) => ({
      template,
      newsletter_only
    }))(payload)
  );
}

export function getEmailTemplates() {
  return fetch.get("/1/auth/getemailtemplates/");
}

export function getUserProfile() {
  return fetch.get("/1/users/getprofile/");
}

export function getUserProfiles(params) {
  return fetch.get("/2/users/getprofiles/", { params }).then(res => res.data);
}

export function editUserProfile(user) {
  return fetch.post(
    "/1/users/editprofile/",
    (({
      newsletter,
      firstname,
      lastname,
      phone,
      company,
      street,
      city,
      province,
      postalcode
    }) => ({
      newsletter,
      firstname,
      lastname,
      phone,
      company,
      street,
      city,
      province,
      postalcode
    }))(user)
  );
}

export function changePassword(password) {
  return fetch.post("/1/users/changepassword/", password);
}

export function resetPassword(email, password) {
  return fetch.post("/1/users/resetpassword/", email, password);
}

export function createPilotPassword(email, password) {
  return fetch.post("/1/users/createpilotpassword/", email, password);
}
